<template>
  <div class="relative">
    <filterbar currentView="grid"></filterbar>

    <div class="flex flex-wrap justify-start [&>*:nth-child(n+13)]:slide-in-from-bottom dark:text-white">

      <div v-if="searchAll" class="w-full h-80 p-6 md:p-10">
        <div class="border-4 border-dashed text-gray-600 border-gray-400 p-8 rounded-xl h-full flex flex-col justify-center items-center">
          <span class="text-7xl mb-4">😭</span>
          <h2 class="text-center text-xl">{{ $t("We could not find a match for your search criteria") }},<br/> {{ $t('please try another search') }}.</h2>
        </div>
      </div>
      <div role="status" v-for="(item, $index) in list" :key="$index"
        class="pt-4 px-2 rounded md:pt-4 md:px-4 w-full xxs:w-1/2 md:w-1/3 md2:w-1/4 lg:w-1/5 md:hover:scale-105 mb-4 transition text-gray dark:text-white duration-300 animate-in fade-in ">
        <transition name="fade">
          <a v-bind:href="`acco/${item.slug}?${params}`"
            class="flex flex-col justify-between h-full">
            <div class="flex items-center relative justify-center h-48 mb-2">
              <vue-load-image class="w-full h-full">
                <img slot="image" v-bind:src="mipmap(item.spotlightimage, 400)" alt=""
                  class="w-full h-full text-gray-200 object-cover shadow-lg rounded-2xl animate-in fade-in transition duration-300"
                  />
                <div slot="preloader"
                  class="w-full h-full object-cover animate-in fade-in duration-300 blur-lg bg-gray-300 dark:bg-neutral-700 rounded-2xl">
                </div>
              </vue-load-image>
              <!-- <carousel :autoplay="true" :autoplayHoverPause="true" :perPage=1 :paginationEnabled="false" :loop="true"
              :autoplayTimeout="3000"
              class="flex-none object-cover w-full max-h-56 md3:max-h-none md3:w-56 rounded-t-lg !h-full md3:h-auto md3:rounded-none md3:rounded-l-md overflow-hidden">
              <slide v-for="(slide, id) in JSON.parse(item.images)" :key="'slide_' + id" class="!h-full">
                <vue-load-image class="!h-full w-full object-cover">
                  <img slot="image" class="object-cover w-full !h-full" :src="mipmap(slide.url, 200)" alt="">
                  <div slot="preloader"
                    class="flex items-center justify-center object-cover w-full !h-full bg-gray-300 animate-pulse">
                    <svg class="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                      fill="currentColor" viewBox="0 0 640 512">
                      <path
                        d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
                    </svg>
                  </div>
                </vue-load-image>
              </slide>
            </carousel> -->
            <div class="absolute top-2 left-2 flex items-start flex-col gap-2">
              <div
                v-if="item.prices && item.prices.priceperNight / item.prices.multiplier < 99999 && !item.prices.priceperNight < 1 && item.prices.multiplier != 1 && item.prices.multiplier != 100"
                class="px-4 h-10 flex justify-center items-center bg-black/50 text-gray-100 backdrop-blur-sm shadow-lg text-sm rounded-full grow-0">
                <div class="flex justify-center items-center capitalize" v-if="item.prices.priceperNight / (item.prices.multiplier/100) > item.prices.priceperNight">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill=currentColor
                    viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path
                      d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                  </svg>
                  {{ $t('discount') }}!
                </div>
                <div
                  v-else-if="item.prices && item.prices.priceperNight / (item.prices.multiplier / 100) < item.prices.priceperNight">
                  {{ $t('Popular!') }} </div>
              </div>
              <a :href="$termsUrl+'#sponsored'" target="blank" v-if="item.promotion && item.promotion == true" class="bg-black/50 backdrop-blur-sm p-2 rounded-full text-gray-200 hover:text-yellow-400 z-5 transition-all duration-500 flex items-center justify-start group max-w-[32px] hover:max-w-full overflow-hidden cursor-help">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                  viewBox="0 0 576 512" class="w-4 h-4 shrink-0">
                  <path
                    d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z">
                  </path>
                </svg>
                <span class="text-xs ml-1 opacity-0 transition group-hover:opacity-100 text-white">{{ $t('sponsored') }}</span>
              </a>
            </div>
              <likebutton :id="item.id" background="bg-black/50 backdrop-blur-sm" color="text-gray-100">
              </likebutton>
            </div>
            <div class="flex justify-between flex-1">
              <div class="pr-2 flex flex-col justify-around items-start">
                <h4 class="mb-1 font-bold text-base leading-4 break-all">{{ item.name.split(",")[0] }}</h4>
                <!-- <div class="flex mb-1 items-center px-2 bg-primary rounded-full text-white">
                <span class="text-sm leading-5">
                  {{ $t('max') }} {{item.maxPeople}} {{ $tc('guest', item.maxPeople) }}
                </span>
              </div> -->
                <div class="flex items-center">
                  <span class="h-3 w-4 mr-1" v-bind:class="'fi fi-' + item.country.toLowerCase()">
                  </span>
                  <span class="text-sm leading-5">{{ item.city }}</span>
                </div>
              </div>
              <div class="flex flex-col justify-around items-end">
                <h5 v-if="item.prices && item.prices.price">
                  <span class="font-bold">€{{ item.prices.price.toFixed(2) }} </span>
                </h5>
                <div class="font-bold text-base leading-4" v-if="item.score">
                  <div class="flex items-center">
                    <svg class="w-4 h-4 text-primary mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 22 20">
                      <path
                        d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                    </svg>
                    <p class="text-sm font-bold text-gray-900">4.95</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </transition>
      </div>
      <infinite-loading @infinite="infiniteHandler" class="w-full">
        <div slot="spinner" class="flex flex-wrap justify-start w-full transition duration-300 animate-in">
          <div role="status" v-for="n in Object.keys(list).length == 0 ? 12 : Object.keys(list).length == 4 ? 8 : 4"
            class="pt-4 px-2 rounded animate-pulse md:pt-4 md:px-4 mb-4 xxs:w-1/2 md:w-1/3 md2:w-1/4 lg:w-1/5"
            :class="{ 'opacity-0': Object.keys(list).length >= 12 }">
            <div class="flex items-center justify-center h-48 mb-2 bg-gray-300 dark:bg-neutral-700 blur-lg rounded-2xl">
              <svg class="w-10 h-10 text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                fill="currentColor" viewBox="0 0 16 20">
                <path
                  d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
              </svg>
            </div>

            <div class="h-4 bg-gray-200 dark:bg-neutral-700 rounded-full w-40 mb-2"></div>
            <div class="h-3 bg-gray-200 dark:bg-neutral-700 rounded-full w-32 mb-2"></div>
            <div class="h-2 bg-gray-200 dark:bg-neutral-700 rounded-full mb-1"></div>
            <div class="h-2 bg-gray-200 dark:bg-neutral-700 rounded-full mb-1"></div>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div slot="no-more"></div>
        <div slot="no-results">No results message</div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import moment from "moment";
import VueCookies from 'vue-cookies'
const { debounce } = require("lodash");
import InfiniteLoading from 'vue-infinite-loading';
import axios from 'axios';


import VueLoadImage from 'vue-load-image'
import _ from 'lodash';
import { Carousel, Slide } from 'vue-carousel';
import helpers from "../helpers";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    InfiniteLoading,
  },
  data() {
    return {
      products: null,
      sortBy: "name",
      page: 1,
      list: [],
      keyword: "",
      showMarkerByIndex: null,
      staticAnchor: [16, 37],
      dataloaded: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      maxZoom: 18,
      markers: [],
      currentUrl: "",
      defaultCenter: [],
      markerinView: "",
      params: [],
      singleCountry: false,
      search: new URLSearchParams(window.location.search),
      searchAll: false,
    };
  },
  methods: {
    mipmap: function mipmap(src, res) {
        if (src) {
            if (src.includes('https://media.xmlcal.com')){ 
                var imgblocks = src.split("/");
                var imgfile = imgblocks[imgblocks.length - 1];
                var thumbnailimgsmall = imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
                imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
                return imgblocks.join("/");
            } else {
                return src;
            }
        } else {
            return 0;
        }
    },
    infiniteHandler($state) {
      var url = 
        this.$BMB_API +'api/' +
        this.$clientID +
        "/getProperties";

      if (!this.searchAll) {
        url = url + window.location.search;
      }
      axios.get(
        url, {
        params: {
          getPrices: true,
          limit: 16,
          page: this.page,
        },
      }).then(({ data }) => {
        this.list = { ...this.list, ...data.data }
        if (data.total == 0) {
          this.searchAll = true;
        } else {
          this.page += 1;
        }
        if (data.to != data.total) {
          $state.loaded();
        } else {
          $state.loaded();
          $state.complete();
        }
      });
    },
    clearSearch() {
      for (const [key, value] of this.search.entries()) {
        VueCookies.remove(key)
      }
      VueCookies.remove('propertyName')
      VueCookies.remove('checkin')
      VueCookies.remove('checkout')
      VueCookies.remove('country')
      VueCookies.remove('numChildren')
      VueCookies.remove('numAdult')
      VueCookies.remove('location')
      VueCookies.remove('accomodation')
      VueCookies.remove('city')
      window.location.href = this.currentUrl + '/accomodations/'
    },
    moveMap(id) {
      if (id != null) {
        if (id !== this.markerinView) {
          var marker = this.markers.find((element) => element[2] === id);
          this.markerinView = id;
          this.center = [marker[0], marker[1]];
        }
      }
    },
    scrollMarker(id) {
      const element = document.getElementById("acco-" + id);
      const yOffset = -element.offsetHeight;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      element.classList.add("focus");
      setTimeout(function () {
        element.classList.remove("focus");
      }, 1000);
    },
  },

  created() {
    this.currentUrl = window.location.origin;
    this.params = new URLSearchParams(document.location.search);
  },

  filters: {
    smallDate: function (date) {
      return moment(date).format('Do MMM');
    }
  },

  computed: {
    receivedAccos: function () {
      if (this.dataloaded) {
        return this.products.data;
      }
    },
  },
};
</script>
